import React, { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

// Redux slices
import { setUserId } from './settingsSlice';
import { setSubPage, setSubPage2 } from '../menu/menuSlice';


/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Components
import AjaxController from '../system/ajaxController';

// Redux slices
import { setActivePage, setUser, setToken } from '../../appSlice';

// SemanticUI components
import { Header, HeaderContent, Icon, Label, Grid, GridRow, GridColumn, Container, Segment } from 'semantic-ui-react'
import { Form, FormGroup, FormSelect, FormInput, FormField, Checkbox, Flag, Accordion, Message } from 'semantic-ui-react'
import { ListItem, ListIcon, ListHeader, ListDescription, ListContent, List } from 'semantic-ui-react'

// Style
import './settings.css';

registerLocale('de', de);
setDefaultLocale('de');




const Max2SettingsUserDetailsHistory = ({historyData}) => {
  return (
    <>
      <Header as='h4'>Historie</Header>

      {(typeof historyData === 'undefined' || historyData === null || !historyData.length === 0) && (
        <List divided relaxed>
          <ListItem>
            <ListContent>
              <ListHeader as='a'>Keine Einträge vorhanden</ListHeader>
            </ListContent>
          </ListItem>
        </List>
      )}

      {typeof historyData !== 'undefined' && historyData !== null && historyData.length > 0 && (
        <List divided relaxed>
          {historyData.map((item, index) => {
            const created_at = format(new Date(item.created_at), 'dd.MM.yyyy HH:mm:ss');
            let icon = <></>;
            switch (item.operation_details.action) {
              case 'LOGIN': icon = <ListIcon name='sign in' />; break;
              case 'LOGOUT': icon = <ListIcon name='log out' />; break;
              case 'OPEN': icon = <ListIcon name='folder open' />; break;
              case 'INSERT': icon = <ListIcon name='file outline' />; break;
              case 'UPDATE': icon = <ListIcon name='save' />; break;
              case 'DELETE': icon = <ListIcon name='trash' />; break;
              default: icon = <ListIcon name='history' />; break;
            }
            return (
              <ListItem key={index}>
                {icon}
                <ListContent>
                  <ListHeader as='a'>{item.operation_text}</ListHeader>
                  <ListDescription>{created_at}, {item.user_name}</ListDescription>
                </ListContent>
              </ListItem>
            )
          })}
        </List>
      )}
    </>
  )
}






/**
 * 
 * @param {integer} userId 
 * @returns 
 */
const Max2SettingsUserDetails = ({userId}) => {
  // local state
  const [isSearching, setIsSearching]               = useState(false);
  const [isLoaded, setIsLoaded]                     = useState(false);
  const [userDetails, setUserDetails]               = useState({ uname: '', name: '', email: ''});
  const [userDetailsOld, setUserDetailsOld]         = useState(null);
  const [metaGroups, setMetaGroups]                 = useState([]);
  const [metaAgencies, setMetaAgencies]             = useState([]);
  const [metaUsers, setMetaUsers]                   = useState([]);
  const [editMode, setEditMode]                     = useState(false);
  const [isDirty, setIsDirty]                       = useState(false);
  const [showPass, setShowPass]                     = useState(false);
  const [showPassRepeat, setShowPassRepeat]         = useState(false);
  const [objectCodesFilter, setObjectCodesFilter]   = useState('');
  const [objectCodesRecords, setObjectCodesRecords] = useState({ numberOfRecordsTotal: 0, numberOfRecords: 0, records: [] });
    
  // global state
  const dispatch = useDispatch();
  const backendUrl    = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

  //
  const languageOptions = [ {key: 'german', value: 'german', text: 'Deutsch'}, {key: 'english', value: 'english', text: 'Englisch'}]

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();
  


  /**
   * 
   * @param {string} column 
   * @param {mixed} value 
   */
  const handleDetailsChange = (column, value) => {
    switch (column) {
      case 'agency': 
        let userAgency = null;
        metaAgencies.forEach(agency => {
          if (parseInt(agency.key) === parseInt(value)) {
            userAgency = agency;
          }
        });
        setUserDetails({...userDetails, agency: userAgency});
        setIsDirty(true);
        break;

      case 'group':
        let userGroups = {...userDetails.groups};
        if (value.id && value.checked) {
          userGroups[value.id] = {id: value.id};
        } else {
          delete userGroups[value.id];
        }
        setUserDetails({...userDetails, groups: userGroups});
        setIsDirty(true);
        break;

      case 'permission':
        let userPermissions = {...userDetails.permissions};
        userPermissions[value.section][value.permission] = value.checked;
        setUserDetails({...userDetails, permissions: userPermissions});
        setIsDirty(true);
        break;

      case 'pass':
        if (typeof userDetails.pass_repeat !== 'undefined' && userDetails.pass_repeat !== '' && userDetails.pass_repeat !== value) {
          enqueueSnackbar('Passworte stimmen nicht überein', { variant: 'error' });
        }
        setUserDetails({...userDetails, pass: value});
        setIsDirty(true);
        break;
      case 'pass_repeat':
        if (typeof userDetails.pass !== 'undefined' && userDetails.pass !== '' && userDetails.pass !== value) {
          enqueueSnackbar('Passworte stimmen nicht überein', { variant: 'error' });
        }
        setUserDetails({...userDetails, pass_repeat: value});
        setIsDirty(true);
        break;
      
      default:
        let changedDetails = {...userDetails};
        changedDetails[column] = value;
        setUserDetails(changedDetails);
        setIsDirty(true);
        break;
    }
  }


  
  /**
   * AJAX API request
   */
  const fetchData = useCallback(async (userId) => {
    try {
      // Controller for AJAX requests
      const api = new AjaxController(backendUrl, () => {
        dispatch(setActivePage('START'));
        dispatch(setUser(null));
        dispatch(setToken(null));
      });

      // show loading animation
      setIsSearching(true);

      // send search request
      const response = await api.get('/settings/user/' + userId);
      
      // display details
      if (response?.user) {
        setUserDetails(response.user)
      }
      if (response?.meta?.groups) {
        setMetaGroups(response.meta.groups)
      }
      if (response?.meta?.agencies) {
        setMetaAgencies(response.meta.agencies)
      }
      if (response?.meta?.users) {
        setMetaUsers(response.meta.users)
      }

      // hide loading animation
      setIsLoaded(true);
      setIsSearching(false);

    } catch (err) {
      //setError(err.message);
      console.error(err.message);
      setIsLoaded(true);
      setIsSearching(false);
    }
  }, [backendUrl, dispatch]);

  /**
   * 
   */
  const loadUserDetails = useCallback(() => {
    // run request
    fetchData(userId);
  }, [fetchData, userId]);

  /**
   * 
   * @param {string} filterValue 
   */
  const handleObjectCodesFilterChange = (filterValue) => {
    setObjectCodesFilter(filterValue);

    if (filterValue.length >= 3) {
      fetchObjectCodes(filterValue);
    }
  }
  


  /**
   * 
   * @param {string} filterValue 
   */
  const fetchObjectCodes = async (filterValue) => {
    const query = {
      filter:     {code: { type: 3, value: filterValue, method: 'BeginsWith' }}, 
      pagination: { recordsPerPage: 99999, actualPage: 1, numberOfPages: 0},
      sorting:    { by: 'code', direction: 'ASC' },
      table:      'icmp006.system_object_codes',
      references: ['icmp_zgbs']
    }
    try {
      // Controller for AJAX requests
      const api = new AjaxController(backendUrl, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
          });

      // send search request
      const count = await api.get('/settings/systemdata_count/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
      const response = await api.get('/settings/systemdata_filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
      
      // display results
      if (response?.records.length) {
        const _result = {
          records: response.records,
          referenced: response.referenced,
          numberOfRecordsTotal: count, 
          numberOfRecords: response.records.length
        }
        setObjectCodesRecords(_result);
      }
    } catch (err) {
      //setError(err.message);
      console.error(err.message);
    }
  };



  /**
   * 
   * @param {object} objectcode 
   */
  const handleAssignObjectCodeClick = (objectcode) => {
    // add single code
    if (objectcode) {
      if (typeof objectCodesRecords.referenced?.icmp_zgbs !== 'undefined') {
        let zgb_name = '';
        objectCodesRecords.referenced?.icmp_zgbs.forEach(zgb => {
          if (zgb.zgbid === objectcode.zgb_id) {
            zgb_name = zgb.name;
          }
        });
  
        const _userDetails = {
          ...userDetails, 
          objectCodes: [
            ...userDetails.objectCodes, 
            {
              id: objectcode.id,
              name: objectcode.code,
              zgb_id: objectcode.zgb_id,
              zgb_name: zgb_name
            }
          ]
        };
        setUserDetails(_userDetails);
        setIsDirty(true);
      }

    // add all codes
    } else {
      let _objectCodes = [...userDetails.objectCodes];
      objectCodesRecords.records.forEach(objectcode => {

        let found = false;
        _objectCodes.forEach(_oc => {
          if (_oc.name === objectcode.code) {
            found = true;
          }
        });

        if (!found) {
          let zgb_name = '';
          objectCodesRecords.referenced?.icmp_zgbs.forEach(zgb => {
            if (zgb.zgbid === objectcode.zgb_id) {
              zgb_name = zgb.name;
            }
          });
  
          _objectCodes.push({
            id: objectcode.id,
            name: objectcode.code,
            zgb_id: objectcode.zgb_id,
            zgb_name: zgb_name
          });
        }
      });
      setUserDetails({...userDetails, objectCodes: _objectCodes});
      setIsDirty(true);
    }
  }



  /**
   * 
   * @param {object} objectcode 
   */
  const handleUnassignObjectCodeClick = (objectcode, zgb_id = false) => {

    let _objectCodes = [];
    userDetails.objectCodes.forEach(oc => {
      if (objectcode && oc.name !== objectcode) {
        _objectCodes.push(oc);
      }
      if (zgb_id && zgb_id !== oc.zgb_id) {
        _objectCodes.push(oc);
      }
    });

    setUserDetails({...userDetails, objectCodes: _objectCodes});
  }



  /**
   *
   */
  const handleEditModeClick = () => {
    setEditMode(true);
    setUserDetailsOld(userDetails);
  }



  /**
   *
   */
  const handleAbortClick = () => {
    setEditMode(false); 
    setIsDirty(false);
    setUserDetails(userDetailsOld);
    setUserDetailsOld(null);
    dispatch(setSubPage2(null));
  }



  /**
   * 
   */
  const handleCloseClick = () => {
    dispatch(setSubPage('Benutzerverwaltung'));
    dispatch(setSubPage2(null));
    setUserDetails(null);
    dispatch(setUserId(null));
  }



  /**
   *
   */
  const handleSaveClick = async () => {
    try {
      // Controller for AJAX requests
      const api = new AjaxController(backendUrl, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
          });

      // send post request
      const response = await api.put('/settings/user/' + userDetails.uid, userDetails);
      if (response?.status === 'success') {
        enqueueSnackbar('Benutzerdaten wurden gespeichert', { variant: 'success' });
        setUserDetailsOld(null);
        setEditMode(false); 
        setIsDirty(false);
      }
    } catch (err) {
      enqueueSnackbar('Fehler beim Speichern der Benutzerdaten', { variant: 'error' });
      console.error(err.message);
      setEditMode(false); 
      setIsDirty(false);
    }
  }



  /**
   * Initialize user list
   */
  useEffect(() => {
    if (!isLoaded) {
      loadUserDetails();
    }
  }, [isLoaded, loadUserDetails]);

  
  // Show placeholder while getting data 
  if (isSearching) {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Header as='h4'>Details</Header>
        <Header as='h2' textAlign='center'>
          <Icon loading name='spinner' />
          <HeaderContent>
            Userdaten werden geladen ...
          </HeaderContent>
        </Header>
      </Segment>
    )
  }
  /**/


  // build group checkboxes
  const groupCheckboxes = metaGroups.map((group, groupKey) => {
    if (editMode) {
      return (
        <FormField key={groupKey}>
          <Checkbox toggle label={group.name} checked={userDetails.groups[group.id]?.id === group.id ? true : false} onClick={()=>handleDetailsChange('group', { id: group.id, checked: userDetails.groups[group.id]?.id === group.id ? false : true })} />
        </FormField>
      )
    }
    if (userDetails?.groups[group.id]?.id === group.id) {
      return (
        <>
        <Icon circular name='users' />{group.name}<br />
        </>
      )
    }

    return <></>
  })

  // build assigned objectcodes list
  let objectcodesGrouped = {};
  userDetails?.objectCodes?.forEach(objectCode => {
    if (typeof objectcodesGrouped[objectCode.zgb_id] === 'undefined') {
      objectcodesGrouped[objectCode.zgb_id] = {
        key: objectCode.zgb_id,
        title: objectCode.zgb_name,
        objectCodes: [],
        content: []
      }
      if (editMode) {
        objectcodesGrouped[objectCode.zgb_id].content.push(
          <FormField key={objectCode.zgb_id} style={{borderBottom: '1px solid silver'}}>
            <Checkbox label='alle' checked={true} onClick={() => handleUnassignObjectCodeClick(false, objectCode.zgb_id)} />
          </FormField>
        )
      }
    }
    objectcodesGrouped[objectCode.zgb_id].objectCodes.push(objectCode.name);
    if (editMode) {
      objectcodesGrouped[objectCode.zgb_id].content.push(
        <FormField key={objectCode.name}>
          <Checkbox label={objectCode.name} checked={true} onClick={() => handleUnassignObjectCodeClick(objectCode.name)} />
        </FormField>
      );
    } else {
      objectcodesGrouped[objectCode.zgb_id].content.push(<>&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;{objectCode.name}<br /></>)
    }
  });
  const objectCodesAccordion = <Accordion defaultActiveIndex={[0]} panels={objectcodesGrouped} exclusive={false} />

  // build available objectcodes checkboxes
  const objectcodesCheckboxes = objectCodesRecords.records.length ? (
    <>
      <FormField>
        <Checkbox label='alle' checked={false} onClick={() => handleAssignObjectCodeClick(false)} />
      </FormField>
      <Container style={{maxHeight: '800px', overflow: 'auto', borderTop: '1px solid silver', paddingTop: '10px'}}>
        {objectCodesRecords.records.map((objectcode) => {
          if (objectcodesGrouped[objectcode.zgb_id]?.objectCodes.includes(objectcode.code)) {
            return <></>;
          }
          return (
            <FormField key={objectcode.code}>
              <Checkbox label={objectcode.code} checked={false} onClick={() => handleAssignObjectCodeClick(objectcode)} />
            </FormField>
          )
        })}
      </Container>
    </>
  ) : <></>;

  





  // Build password fields
  const inputPass = showPass 
  ? <FormInput fluid label="Passwort"     value={userDetails?.pass} action={{content: 'verstecken', onClick: () => setShowPass(false)}} icon='key' iconPosition='left' onChange = {(e, data) => handleDetailsChange('pass', data.value)} />
  : <FormInput fluid label="Passwort"     value={userDetails?.pass} action={{content: 'anzeigen',   onClick: () => setShowPass(true)}}  icon='key' iconPosition='left' onChange = {(e, data) => handleDetailsChange('pass', data.value)} type='password' />
  
  const inputPassRepeat = showPassRepeat 
  ? <FormInput fluid label="Wiederholung" value={userDetails?.pass_repeat} action={{content: 'verstecken', onClick: () => setShowPassRepeat(false)}} icon='key' iconPosition='left' onChange = {(e, data) => handleDetailsChange('pass_repeat', data.value)} />
  : <FormInput fluid label="Wiederholung" value={userDetails?.pass_repeat} action={{content: 'anzeigen',   onClick: () => setShowPassRepeat(true)}}  icon='key' iconPosition='left' onChange = {(e, data) => handleDetailsChange('pass_repeat', data.value)} type='password' />
  
  //
  if (editMode) {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        
        <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>Benutzerdetails &laquo;{userDetails.uname}&raquo;</span></Label>
        <div style={{position: 'absolute', top: '5px', right: '5px'}}>
          <Icon link size='large' name='times' onClick={()=>handleAbortClick() } />
          {isDirty && (<Icon link size='large' name='save' onClick={()=>handleSaveClick()} />)}
        </div>

        <Grid style={{margin: '25px'}}>
          <GridRow> 
            <GridColumn width={7}>
              <Header as='h4'>Details</Header>
              <Form>
                <FormInput fluid label="E-Mail"             value={userDetails.email} onChange = {(e, data) => handleDetailsChange('email', data.value)} />
                <FormGroup widths='equal'>
                    {inputPass}
                    {inputPassRepeat}
                </FormGroup>
                <br /><br />
                <FormInput fluid label="Anzeigename"        value={userDetails.displayname} onChange = {(e, data) => handleDetailsChange('displayname', data.value)} />
                <FormGroup widths='equal'>
                  <FormInput fluid label="Vorame"           value={userDetails.forename} onChange = {(e, data) => handleDetailsChange('forename', data.value)} />
                  <FormInput fluid label="Nachname"         value={userDetails.surename} onChange = {(e, data) => handleDetailsChange('surename', data.value)} />
                </FormGroup>
                <FormInput fluid label="Telefon"            value={userDetails.telephone} onChange = {(e, data) => handleDetailsChange('telephone', data.value)} />
                {/*<FormSelect fluid label="Anzeigesprache"    value={userDetails.language} options={languageOptions} onChange = {(e, data) => handleDetailsChange('language', data.value)} />*/}
                <br /><br />
                <FormSelect fluid label="Agentur"           value={userDetails?.agency?.id} options={metaAgencies} onChange = {(e, data) => handleDetailsChange('agency', data.value)} search clearable />
                <br /><br />
                <FormSelect fluid label="Referenz-Benutzer" value={userDetails.reference_uid} options={metaUsers} onChange = {(e, data) => handleDetailsChange('reference_uid', data.value)} search clearable />
                <br /><br />
                <label>Gruppenzugehörigkeit</label><br />
                <div style={{padding: '10px'}}>{groupCheckboxes}</div>
              </Form>
            </GridColumn>
    
            <GridColumn width={4}>
              <Header as='h4'>Rechte/Zugriffssteuerung</Header>
              <Form>
                <label>Systemsteuerung</label><br />
                <div style={{padding: '10px', marginBottom: '25px', borderTop: '1px solid silver'}}>
                  <FormField>
                    <Checkbox toggle label="Lesezurgriff" checked={userDetails?.permissions?.system?.read} onClick={()=>handleDetailsChange('permission', { section: 'system', permission: 'read',  checked: userDetails?.permissions?.system?.read ? false : true })} />
                  </FormField>
                  <FormField>
                    <Checkbox toggle label="Schreibzugriff" checked={userDetails?.permissions?.system?.write} onClick={()=>handleDetailsChange('permission', { section: 'system', permission: 'write',  checked: userDetails?.permissions?.system?.write ? false : true })} />
                  </FormField>
                </div>

                <label>Hotel/Objekt</label><br />
                <div style={{padding: '10px', marginBottom: '25px', borderTop: '1px solid silver'}}>
                  <FormField>
                    <Checkbox toggle label="Lesezurgriff" checked={userDetails?.permissions?.object?.read} onClick={()=>handleDetailsChange('permission', { section: 'object', permission: 'read',  checked: userDetails?.permissions?.object?.read ? false : true })} />
                  </FormField>
                  <FormField>
                    <Checkbox toggle label="Schreibzugriff" checked={userDetails?.permissions?.object?.write} onClick={()=>handleDetailsChange('permission', { section: 'object', permission: 'write',  checked: userDetails?.permissions?.object?.write ? false : true })} />
                  </FormField>
                  <FormField>
                    <Checkbox toggle label="Hotelbilder" checked={userDetails?.permissions?.object?.addMedia} onClick={()=>handleDetailsChange('permission', { section: 'object', permission: 'addMedia',  checked: userDetails?.permissions?.object?.addMedia ? false : true })} />
                  </FormField>
                  <FormField>
                    <Checkbox toggle label="Beschreibungen" checked={userDetails?.permissions?.object?.descriptions} onClick={()=>handleDetailsChange('permission', { section: 'object', permission: 'descriptions',  checked: userDetails?.permissions?.object?.descriptions ? false : true })} />
                  </FormField>
                  <FormField>
                    <Checkbox toggle label="Verträge" checked={userDetails?.permissions?.object?.contracts} onClick={()=>handleDetailsChange('permission', { section: 'object', permission: 'contracts',  checked: userDetails?.permissions?.object?.contracts ? false : true })} />
                  </FormField>
                  <FormField>
                    <Checkbox toggle label="Exporte" checked={userDetails?.permissions?.object?.exports} onClick={()=>handleDetailsChange('permission', { section: 'object', permission: 'exports',  checked: userDetails?.permissions?.object?.exports ? false : true })} />
                  </FormField>
                </div>

                <label>Vertrag</label><br />
                <div style={{padding: '10px', marginBottom: '25px', borderTop: '1px solid silver'}}>
                  <FormField>
                    <Checkbox toggle label="Lesezurgriff" checked={userDetails?.permissions?.contract?.read} onClick={()=>handleDetailsChange('permission', { section: 'contract', permission: 'read',  checked: userDetails?.permissions?.contract?.read ? false : true })} />
                  </FormField>
                  <FormField>
                    <Checkbox toggle label="Schreibzugriff" checked={userDetails?.permissions?.contract?.write} onClick={()=>handleDetailsChange('permission', { section: 'contract', permission: 'write',  checked: userDetails?.permissions?.contract?.write ? false : true })} />
                  </FormField>
                  <FormField>
                    <Checkbox toggle label="Erweiterte Ansicht / HeadOffice" checked={userDetails?.permissions?.contract?.headoffice} onClick={()=>handleDetailsChange('permission', { section: 'contract', permission: 'headoffice',  checked: userDetails?.permissions?.contract?.headoffice ? false : true })} />
                  </FormField>
                  <FormField>
                    <Checkbox toggle label="Vertragsadministration" checked={userDetails?.permissions?.contract?.management} onClick={()=>handleDetailsChange('permission', { section: 'contract', permission: 'management',  checked: userDetails?.permissions?.system?.management ? false : true })} />
                  </FormField>
                </div>

                <label>Allotments</label><br />
                <div style={{padding: '10px', marginBottom: '25px', borderTop: '1px solid silver'}}>
                  <FormField>
                    <Checkbox toggle label="Lesezurgriff" checked={userDetails?.permissions?.allotments?.read} onClick={()=>handleDetailsChange('permission', { section: 'allotments', permission: 'read',  checked: userDetails?.permissions?.allotments?.read ? false : true })} />
                  </FormField>
                  <FormField>
                    <Checkbox toggle label="Schreibzugriff" checked={userDetails?.permissions?.allotments?.write} onClick={()=>handleDetailsChange('permission', { section: 'allotments', permission: 'write',  checked: userDetails?.permissions?.allotments?.write ? false : true })} />
                  </FormField>
                </div>
              </Form>
            </GridColumn>
    
            <GridColumn width={5}>
              <Header as='h4'>Objektcode-Zuordnungen</Header>
              <Grid columns={2}>
                <GridColumn>
                  <Form>
                    <label>zugewiesen:</label><br />
                  </Form>
                  {!userDetails?.objectCodes.length && (<Message icon='info' content='Sind keine Objektcodes zugewiesen, bedeutet das keine Einschränkung vorliegt' />)}
                  <Container style={{maxHeight: '800px', overflow: 'auto', borderTop: '1px solid silver', padding: '10px'}}>
                    {objectCodesAccordion}
                  </Container>
                </GridColumn>
                <GridColumn>
                  <Form>
                    <label>verfügbar: </label><br />
                    <Container style={{borderTop: '1px solid silver', paddingTop: '10px'}}>
                      <FormGroup inline>
                        <FormField>
                          <FormInput icon='search' iconPosition='left' value={objectCodesFilter} placeholder='PMI123B' onChange = {(e, data) => handleObjectCodesFilterChange(data.value)} />
                        </FormField>
                      </FormGroup>
                    </Container>
                  </Form>
                  {objectcodesCheckboxes}
                </GridColumn>
              </Grid>
              {/*
              <Header as='h4'>Externe Provider</Header>
              <Container style={{maxHeight: '800px', overflow: 'auto', borderTop: '1px solid silver', padding: '10px'}}>
                <Form>
                  <FormField><Checkbox toggle label="CRE - Cretan" checked={userDetails?.provider?.CRE} /></FormField>
                  <FormField><Checkbox toggle label="DER - DERTour" checked={userDetails?.provider?.DER} /></FormField>
                  <FormField><Checkbox toggle label="EXP - Expedia" checked={userDetails?.provider?.EXP} /></FormField>
                  <FormField><Checkbox toggle label="GTA" checked={userDetails?.provider?.GTA} /></FormField>
                  <FormField><Checkbox toggle label="HTB - HotelBeds" checked={userDetails?.provider?.HTB} /></FormField>
                  <FormField><Checkbox toggle label="MIK - Miki" checked={userDetails?.provider?.MIK} /></FormField>
                  <FormField><Checkbox toggle label="OTS" checked={userDetails?.provider?.OTS} /></FormField>
                  <FormField><Checkbox toggle label="SHO - SunHotels" checked={userDetails?.provider?.SHO} /></FormField>
                  <FormField><Checkbox toggle label="TOURH" checked={userDetails?.provider?.TOURH} /></FormField>
                  <FormField><Checkbox toggle label="TUK - TouricoUK" checked={userDetails?.provider?.TUK} /></FormField>
                  <FormField><Checkbox toggle label="TZO - TravelZoo" checked={userDetails?.provider?.TZO} /></FormField>
                  <FormField><Checkbox toggle label="W2M - World2Meet" checked={userDetails?.provider?.W2M} /></FormField>
                </Form>
              </Container>
              */}
            </GridColumn>
          </GridRow>
        </Grid>
      </Segment>
    )
  }





  // Reference-User
  let ref_user = '';
  metaUsers.forEach(user => {
    if (parseInt(user.key) === parseInt(userDetails?.reference_uid)) {
      ref_user = user.text;
    }
  });

  // Date formatting
  const regdate   = userDetails?.regdate ? format(new Date(userDetails?.regdate * 1000), 'dd.MM.yyyy HH:mm') + ' Uhr' : '';
  const lastlogin = userDetails?.lastlogin ? format(new Date(userDetails?.lastlogin * 1000), 'dd.MM.yyyy HH:mm') + ' Uhr' : '';

  return (
    <>
    <Segment textAlign='left' style={{margin: '25px'}}>
      <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>Benutzerdetails &laquo;{userDetails?.uname}&raquo;</span></Label>
      <div style={{position: 'absolute', top: '5px', right: '5px'}}>
        <Icon link size='large' name='times' onClick={()=>handleCloseClick()} />
        <Icon link size='large' name='edit' onClick={()=>handleEditModeClick()} />
      </div>
      <Grid style={{margin: '25px'}}>
        <GridRow> 
          <GridColumn width={6}>
            <Header as='h4'>Details</Header>
            <Grid>
              <GridRow className='ro_row'><GridColumn width={4} className='ro_label' textAlign='right'>Benutzerkennung</GridColumn><GridColumn width={12}>{userDetails?.uname}</GridColumn></GridRow>
              <GridRow className='ro_row'><GridColumn width={4} className='ro_label' textAlign='right'>E-Mail</GridColumn><GridColumn width={12}>{userDetails?.email}</GridColumn></GridRow>
            </Grid>
            <br /><br />
            <Grid>
              <GridRow className='ro_row'><GridColumn width={4} className='ro_label' textAlign='right'>Anzeigename</GridColumn><GridColumn width={12}>{userDetails?.displayname}</GridColumn></GridRow>
              <GridRow className='ro_row'><GridColumn width={4} className='ro_label' textAlign='right'>Vorame</GridColumn><GridColumn width={12}>{userDetails?.forename}</GridColumn></GridRow>
              <GridRow className='ro_row'><GridColumn width={4} className='ro_label' textAlign='right'>Nachname</GridColumn><GridColumn width={12}>{userDetails?.surename}</GridColumn></GridRow>
              <GridRow className='ro_row'><GridColumn width={4} className='ro_label' textAlign='right'>Telefon</GridColumn><GridColumn width={12}>{userDetails?.telephone}</GridColumn></GridRow>
              {/*<GridRow className='ro_row'><GridColumn width={4} className='ro_label' textAlign='right'>Anzeigesprache</GridColumn><GridColumn width={12}><Flag name={userDetails?.language === 'german' ? 'de' : 'uk'} /></GridColumn></GridRow>*/}
            </Grid>
            <br /><br />
            <Grid>
              <GridRow className='ro_row'><GridColumn width={4} className='ro_label' textAlign='right'>Agentur</GridColumn><GridColumn width={12}>{userDetails?.agency?.name}</GridColumn></GridRow>
            </Grid>
            <br /><br />
            <Grid>
              <GridRow className='ro_row'><GridColumn width={4} className='ro_label' textAlign='right'>Referenz-Benutzer</GridColumn><GridColumn width={12}>{ref_user}</GridColumn></GridRow>
            </Grid>
            <br /><br />
            <Grid>
              <GridRow className='ro_row'><GridColumn width={4} className='ro_label' textAlign='right'>Letzter Login</GridColumn><GridColumn width={12}>{lastlogin}</GridColumn></GridRow>
              <GridRow className='ro_row'><GridColumn width={4} className='ro_label' textAlign='right'>Registrierdatum</GridColumn><GridColumn width={12}>{regdate}</GridColumn></GridRow>
            </Grid>
            <br /><br />
            <Grid>
              <GridRow className='ro_row'>
                <GridColumn width={4} className='ro_label' textAlign='right'>Gruppenzugehörigkeit</GridColumn>
                <GridColumn width={12}>{groupCheckboxes}</GridColumn>
              </GridRow>
            </Grid>
          </GridColumn>

          <GridColumn width={4}>
            <Header as='h4'>Rechte/Zugriffssteuerung</Header>
            <Container style={{maxHeight: '800px', overflow: 'auto', borderTop: '1px solid silver', padding: '10px'}}>
              <label>Systemsteuerung</label><br />
              <div style={{padding: '10px', marginBottom: '25px'}}>
                {userDetails?.permissions?.system?.read && (<><Icon circular name='check' />Lesezurgriff<br /></>)}
                {userDetails?.permissions?.system?.write && (<><Icon circular name='check' />Schreibzugriff<br /></>)}
              </div>

              <label>Hotel/Objekt</label><br />
              <div style={{padding: '10px', marginBottom: '25px'}}>
                {userDetails?.permissions?.object?.read && (<><Icon circular name='check' />Lesezurgriff<br /></>)}
                {userDetails?.permissions?.object?.write && (<><Icon circular name='check' />Schreibzugriff<br /></>)}
                {userDetails?.permissions?.object?.addMedia && (<><Icon circular name='check' />Hotelbilder<br /></>)}
                {userDetails?.permissions?.object?.descriptions && (<><Icon circular name='check' />Hotelbeschreibungen<br /></>)}
                {userDetails?.permissions?.object?.contracts && (<><Icon circular name='check' />Verträge<br /></>)}
                {userDetails?.permissions?.object?.exports && (<><Icon circular name='check' />Exporte<br /></>)}
              </div>

              <label>Vertrag</label><br />
              <div style={{padding: '10px', marginBottom: '25px'}}>
                {userDetails?.permissions?.contract?.read && (<><Icon circular name='check' />Lesezurgriff<br /></>)}
                {userDetails?.permissions?.contract?.write && (<><Icon circular name='check' />Schreibzugriff<br /></>)}
                {userDetails?.permissions?.contract?.headoffice && (<><Icon circular name='check' />Erweiterte Ansicht / HeadOffice<br /></>)}
                {userDetails?.permissions?.contract?.management && (<><Icon circular name='check' />Vertragsadministration<br /></>)}
              </div>

              <label>Allotments</label><br />
              <div style={{padding: '10px', marginBottom: '25px'}}>
                {userDetails?.permissions?.allotments?.read && (<><Icon circular name='check' />Lesezurgriff<br /></>)}
                {userDetails?.permissions?.allotments?.write && (<><Icon circular name='check' />Schreibzugriff<br /></>)}
              </div>
            </Container>
          </GridColumn>

          <GridColumn width={6}>
            <Header as='h4'>Objektcode-Zuordnungen (intern)</Header>
            <Container style={{maxHeight: '800px', overflow: 'auto', borderTop: '1px solid silver', padding: '10px'}}>
              {objectCodesAccordion}
            </Container>
            {/*
            <Header as='h4'>Externe Provider</Header>
            <Container style={{maxHeight: '800px', overflow: 'auto', borderTop: '1px solid silver', padding: '10px'}}>
              {userDetails?.provider?.CRE && (<><Icon circular name='check' />CRE - Cretan<br /></>)}
              {userDetails?.provider?.DER && (<><Icon circular name='check' />DER - DERTour<br /></>)}
              {userDetails?.provider?.EXP && (<><Icon circular name='check' />EXP - Expedia<br /></>)}
              {userDetails?.provider?.GTA && (<><Icon circular name='check' />GTA<br /></>)}
              {userDetails?.provider?.HTB && (<><Icon circular name='check' />HTB - HotelBeds<br /></>)}
              {userDetails?.provider?.MIK && (<><Icon circular name='check' />MIK - Miki<br /></>)}
              {userDetails?.provider?.OTS && (<><Icon circular name='check' />OTS<br /></>)}
              {userDetails?.provider?.SHO && (<><Icon circular name='check' />SHO - SunHotels<br /></>)}
              {userDetails?.provider?.TOURH && (<><Icon circular name='check' />TOURH<br /></>)}
              {userDetails?.provider?.TUK && (<><Icon circular name='check' />TUK - TouricoUK<br /></>)}
              {userDetails?.provider?.TZO && (<><Icon circular name='check' />TZO - TravelZoo<br /></>)}
              {userDetails?.provider?.W2M && (<><Icon circular name='check' />W2M - World2Meet<br /></>)}
            </Container>
            */}
          </GridColumn>
        </GridRow>
      </Grid>
    </Segment>

    <Segment textAlign='left' style={{margin: '25px', paddingLeft: '50px', paddingRight: '50px'}}>
      <Max2SettingsUserDetailsHistory historyData={userDetails?.history}/>
    </Segment>
    </>
  )
}

export default Max2SettingsUserDetails;